export default __webpack_public_path__ + "static/media/employee-icon.2467e233.svg";